import React, { useState } from "react";
// import useSWR, { mutate } from "swr";
import { useNavigationEvent } from "navigation-react";
// import SecureLS from "secure-ls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import useSWR from "swr";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });
const usercsrf_token = ls.get("usercsrf_token");

const fetcher = (url) =>
  fetch(url, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": usercsrf_token,
    },
  })
    .then((res) => res.json())
    .then((data) => (Array.isArray(data) ? data : [data]));

const AddCTScanReportRegister = ({
  requestNID,
  patientNID,
  patient_fullname,
  requestInvestigationPrice,
}) => {
  const { stateNavigator } = useNavigationEvent();

  // console.log("REQUEST NODE ID FOR ADD CT SCAN REPORT REGISTER", requestNID);
  // console.log("PATIENT NODE ID FOR ADD CT SCAN REPORT REGISTER", patientNID);

  const [loading, setLoading] = useState(false);
  const [ctscanReportTitle, setctscanReportTitle] = useState("");
  const [ctscanReportTechnique, setctscanReportTechnique] = useState("");
  const [ctscanFindings, setctscanFindings] = useState("");
  const [ctscanImpression, setctscanImpression] = useState("");
  const [ctscanreportStatus, setctscanreportStatus] = useState("");

  const {
    data: reporterCommissionData,
    // eslint-disable-next-line no-unused-vars
    error: reporterCommissionError,
    // eslint-disable-next-line no-unused-vars
    isLoading: reporterCommissionIsloading,
  } = useSWR(
    `${process.env.REACT_APP_REPORTER_COMMISSION_PERCENTAGE}`,
    fetcher,
  );
  // console.log(
  //   "reporterCommissionData",
  //   reporterCommissionData?.[0].field_ct_scan_reporter_commissio[0].value
  // );

  const {
    data: requesterCommissionData,
    // eslint-disable-next-line no-unused-vars
    error: requesterCommissionError,
    // eslint-disable-next-line no-unused-vars
    isLoading: requesterCommissionIsloading,
  } = useSWR(
    `${process.env.REACT_APP_REQUESTER_COMMISSION_PERCENTAGE}`,
    fetcher,
  );
  // console.log(
  //   "requesterCommissionData",
  //   requesterCommissionData?.[0].field_ct_scan_requester_commissi[0].value
  // );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Refresh token before submitting
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/session/token`,
        {
          credentials: "include",
        },
      );
      const freshToken = await res.text();

      // 1️⃣ CREATE CT SCAN REPORT NODE
      const reportAddPayload = {
        type: [{ target_id: "ct_scan_report" }],
        title: [{ value: ctscanReportTitle }],
        field_ctscan_report_patient_id: [{ target_id: patientNID }],
        field_ctscan_request_id: [{ target_id: requestNID }],
        field_ct_scan_report_technique: [
          { value: ctscanReportTechnique, format: "basic_html" },
        ],
        field_ct_scan_report_findings: [
          { value: ctscanFindings, format: "basic_html" },
        ],
        field_ct_scan_report_impression: [
          { value: ctscanImpression, format: "basic_html" },
        ],
        field_ct_scan_report_status: [{ value: ctscanreportStatus }],
      };

      const reportAddResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/node?_format=json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": freshToken,
          },
          credentials: "include",
          body: JSON.stringify(reportAddPayload),
        },
      );

      if (!reportAddResponse.ok) {
        const error = await reportAddResponse.json();
        console.log("Failed to create report:", error);
        alert(`Failed to create report: ${error.message}`);
        return;
      }

      const reportData = await reportAddResponse.json();
      console.log("ADDING REPORT DATA:", reportData);

      // 2️⃣ CALCULATE REPORTER COMMISSION
      const report_field_investigation_price = requestInvestigationPrice || 0;
      const reportPercent =
        (report_field_investigation_price *
          reporterCommissionData?.[0]?.field_ct_scan_reporter_commissio?.[0]
            ?.value) /
        100;

      // 3️⃣ CREATE REPORTER PAYMENT NODE
      const reportPaymentPayload = {
        type: [{ target_id: "payment" }],
        title: [{ value: patient_fullname }],
        field_ctscan_payment_patient_id: [{ target_id: patientNID }],
        field_payment_reference_for_repo: [
          { target_id: reportData.nid[0].value },
        ],
        field_payment_reference_for_requ: [{ target_id: requestNID }],
        field_reporter_payment_commissio: [{ value: reportPercent }],
        field_payment_ref_for_rep_date: [
          { value: reportData.created[0].value },
        ],
        field_reporter_payment_comm_perc: [
          {
            value:
              reporterCommissionData?.[0]?.field_ct_scan_reporter_commissio?.[0]
                ?.value,
          },
        ],
      };

      const reportPaymentResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/node?_format=json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": freshToken,
          },
          credentials: "include",
          body: JSON.stringify(reportPaymentPayload),
        },
      );

      if (!reportPaymentResponse.ok) {
        const error = await reportPaymentResponse.json();
        console.log("Failed to create payment report:", error);
        alert(`Failed to create payment report: ${error.message}`);
        return;
      }

      const reportPaymentData = await reportPaymentResponse.json();
      console.log("REPORT PAYMENT DATA:", reportPaymentData);

      // 4️⃣ PATCH REPORT WITH PAYMENT REFERENCE
      const reportPatchPaymentPayload = {
        type: [{ target_id: "ct_scan_report" }],
        field_ctscan_report_payment_id: [
          { target_id: reportPaymentData.nid[0].value },
        ],
      };

      const reportPatchPaymentResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/node/${reportData.nid[0].value}?_format=json`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": freshToken,
          },
          credentials: "include",
          body: JSON.stringify(reportPatchPaymentPayload),
        },
      );

      if (!reportPatchPaymentResponse.ok) {
        const error = await reportPatchPaymentResponse.json();
        console.log("Failed to patch payment report:", error);
        alert(`Failed to patch payment report: ${error.message}`);
        return;
      }

      const reportPatchPaymentData = await reportPatchPaymentResponse.json();
      console.log("REPORT PATCH PAYMENT DATA:", reportPatchPaymentData);

      // 5️⃣ PATCH CT SCAN REQUEST WITH REPORT + PAYMENT REFERENCES
      try {
        const requestPayload = {
          type: [{ target_id: "ct_scan_request" }],
          field_ctscan_report_id: [{ target_id: reportData.nid[0].value }],
          field_ctscan_request_payment_id: [
            { target_id: reportPaymentData?.nid[0].value },
          ],
        };

        const requestResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/node/${requestNID}?_format=json`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": freshToken,
            },
            credentials: "include",
            body: JSON.stringify(requestPayload),
          },
        );

        if (!requestResponse.ok) {
          const requesterror = await requestResponse.json();
          console.error("Failed to patch request:", requesterror);
          alert(`Failed to patch request: ${requesterror.message}`);
          return;
        }

        // 6️⃣ CALCULATE REQUESTER COMMISSION
        const request_field_investigation_price =
          requestInvestigationPrice || 0;
        const requestPercent =
          (request_field_investigation_price *
            requesterCommissionData?.[0]?.field_ct_scan_requester_commissi?.[0]
              ?.value) /
          100;

        // 7️⃣ CREATE REQUESTER PAYMENT NODE
        const requestPaymentPayload = {
          type: [{ target_id: "payment" }],
          field_requester_payment_commissi: [{ value: requestPercent }],
          field_payment_ref_for_req_date: [
            { value: reportData.created[0].value },
          ],
          field_requester_payment_com_perc: [
            {
              value:
                requesterCommissionData?.[0]
                  ?.field_ct_scan_requester_commissi?.[0]?.value,
            },
          ],
        };

        const requestPaymentResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/node/${reportPaymentData?.nid[0].value}?_format=json`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": freshToken,
            },
            credentials: "include",
            body: JSON.stringify(requestPaymentPayload),
          },
        );

        if (!requestPaymentResponse.ok) {
          const error = await requestPaymentResponse.json();
          console.log("Failed to create requester payment:", error);
          alert(`Failed to create requester payment: ${error.message}`);
          return;
        }

        const requestPaymentData = await requestPaymentResponse.json();
        console.log("REQUEST PAYMENT DATA:", requestPaymentData);
      } catch (err) {
        console.error("Error patching request:", err);
        alert("Error patching request.");
      }

      alert("Report added successfully!");
      stateNavigator.navigate("ctscanreportregister");
    } catch (err) {
      console.error("Error creating report:", err);
      alert("Network or authentication error.");
    }
  };

  return (
    <div className="add-ctscan-report-register">
      <form onSubmit={handleSubmit} className="patient-form">
        <div className="form-group">
          <label>Report title</label>
          <input
            type="text"
            placeholder="Add Report Title"
            value={ctscanReportTitle}
            onChange={(e) => setctscanReportTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Technique</label>
          <textarea
            placeholder="Add Technique"
            value={ctscanReportTechnique}
            onChange={(e) => setctscanReportTechnique(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Findings</label>
          <textarea
            placeholder="Add Findings"
            value={ctscanFindings}
            onChange={(e) => setctscanFindings(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Impression</label>
          <textarea
            placeholder="Add Impression"
            value={ctscanImpression}
            onChange={(e) => setctscanImpression(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Status</label>
          <select
            value={ctscanreportStatus}
            onChange={(e) => setctscanreportStatus(e.target.value)}
            required
          >
            <option value="">Select Status</option>
            <option value="pending">Pending</option>
            {/* <option value="assigned">Assigned</option> */}
            <option value="completed">Completed</option>
          </select>
        </div>
        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCTScanReportRegister;
